import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-169">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-50 sm:hidden flex items-center justify-between gap-4" data-id="element-170">
          <div className="flex flex-col" data-id="element-171">
            <span className="text-xs text-[#aaa] line-through" data-id="element-172">$59.99</span>
            <span className="text-xl font-bold text-brand-black" data-id="element-173">$24.99</span>
          </div>
          <div className="flex-1 flex flex-col items-center" data-id="element-174">
            <p className="text-yellow-600 text-xs font-semibold mb-1 flex items-center gap-1" data-id="element-175">
              <span data-id="element-176">⚠️</span> Limited stock – selling fast
            </p>
            <a href="https://zenifyliving.com/cart/48194365325482:1?checkout" className="block w-full text-center bg-brand-purple hover:bg-brand-purple-dark text-white font-bold py-3 px-4 rounded-full shadow-lg active:scale-95 transition-transform" data-id="element-177">
              GET INSTANT RELIEF
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}